import React, { createContext, type ReactNode, useContext } from 'react';

import { useConfig } from './config-context';

export const UniqueFieldSuffixContext = createContext<string | undefined>(
  undefined,
);

export const UniqueFieldSuffixContextProvider = ({
  parentId = 'id',
  children,
}: {
  children: ReactNode;
  parentId?: string;
}) => {
  const { compId = 'comp' } = useConfig();
  const uniqueId = `${compId}-${parentId.split('-').at(0)}`;

  return (
    <UniqueFieldSuffixContext.Provider value={uniqueId}>
      {children}
    </UniqueFieldSuffixContext.Provider>
  );
};

export function useUniqueFieldSuffix() {
  const context = useContext(UniqueFieldSuffixContext);
  if (context === undefined) {
    throw new Error(
      'useUniqueFieldSuffix must be used within a UniqueFieldSuffixContextProvider',
    );
  }

  return context;
}
